import { render, staticRenderFns } from "./BatchSendToBoss.vue?vue&type=template&id=53f13834&scoped=true"
import script from "./BatchSendToBoss.vue?vue&type=script&lang=js"
export * from "./BatchSendToBoss.vue?vue&type=script&lang=js"
import style0 from "./BatchSendToBoss.vue?vue&type=style&index=0&id=53f13834&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f13834",
  null
  
)

export default component.exports